module.exports = __webpack_public_path__ + "main.png?304434fb7dfaba777fb5bb295065f1b7";